function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "security-tier-2_svg__linear-gradient",
  x1: 397.43,
  y1: 614.86,
  x2: 250.34,
  y2: 12.83,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#371447"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  stopColor: "#491c5d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.57,
  stopColor: "#592472"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "#5f2779"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "security-tier-2_svg__linear-gradient-2",
  x1: 300,
  y1: 524.5,
  x2: 300,
  y2: -72.22,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#5f2779"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.27,
  stopColor: "#592472"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#491c5d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#371447"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "security-tier-2_svg__linear-gradient-4",
  x1: 56.01,
  y1: 178.18,
  x2: 520.14,
  y2: 368.34,
  gradientTransform: "rotate(-35.7 325.177 288.456)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#371447"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "#3a174a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.36,
  stopColor: "#73498a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.65,
  stopColor: "#9c6db9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#b584d5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#bf8ce0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "security-tier-2_svg__linear-gradient-5",
  x1: 164.15,
  y1: 309.8,
  x2: 435.85,
  y2: 309.8,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#9eefe1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.22,
  stopColor: "#9ceee0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3,
  stopColor: "#95ebdc"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.36,
  stopColor: "#89e6d6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#79dfcc"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#63d5c0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.48,
  stopColor: "#48cab2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#33c1a6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.52,
  stopColor: "#3ec6ac"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#5cd3bd"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.61,
  stopColor: "#74ddca"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#87e5d4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.74,
  stopColor: "#94ebdc"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#9ceee0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9eefe1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "security-tier-2_svg__linear-gradient-6",
  x1: 308.65,
  y1: 372.04,
  x2: 308.65,
  y2: 234.73,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#cb3974"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.93,
  stopColor: "#ffb7d1"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "security-tier-2_svg__clip-path"
}, /*#__PURE__*/React.createElement("path", {
  className: "security-tier-2_svg__cls-1",
  d: "M136.66 76.07h326.68A36.63 36.63 0 01500 112.7v211.83c0 110.44-134.27 200-200 200-69.51 0-200-89.53-200-200V112.7a36.63 36.63 0 0136.66-36.63z"
})), /*#__PURE__*/React.createElement("style", null, ".security-tier-2_svg__cls-1,.security-tier-2_svg__cls-11,.security-tier-2_svg__cls-12,.security-tier-2_svg__cls-15{fill:none}.security-tier-2_svg__cls-1{stroke:#5f2779}.security-tier-2_svg__cls-1,.security-tier-2_svg__cls-11,.security-tier-2_svg__cls-12,.security-tier-2_svg__cls-15{stroke-miterlimit:10}.security-tier-2_svg__cls-1{stroke-width:10px}.security-tier-2_svg__cls-3{fill:url(#security-tier-2_svg__linear-gradient-2)}.security-tier-2_svg__cls-7{fill:#cca1e5}.security-tier-2_svg__cls-9{fill:#bf8ce0;opacity:.3}.security-tier-2_svg__cls-11,.security-tier-2_svg__cls-12{stroke:#cca1e5}.security-tier-2_svg__cls-11,.security-tier-2_svg__cls-12,.security-tier-2_svg__cls-15{stroke-linecap:round}.security-tier-2_svg__cls-11,.security-tier-2_svg__cls-12{stroke-width:2.45px}.security-tier-2_svg__cls-15{stroke:#1c988a;stroke-width:4.88px;opacity:.2}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M117.88 50h364.24A40.83 40.83 0 01523 90.84V327c0 123.14-149.7 223-223 223-77.51 0-223-99.82-223-223V90.84A40.83 40.83 0 01117.88 50z",
  fill: "url(#security-tier-2_svg__linear-gradient)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "security-tier-2_svg__cls-3",
  d: "M136.66 76.07h326.68A36.63 36.63 0 01500 112.7v211.83c0 110.44-134.27 200-200 200-69.51 0-200-89.53-200-200V112.7a36.63 36.63 0 0136.66-36.63z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "security-tier-2_svg__cls-3",
  d: "M136.66 76.07h326.68A36.63 36.63 0 01500 112.7v211.83c0 110.44-134.27 200-200 200-69.51 0-200-89.53-200-200V112.7a36.63 36.63 0 0136.66-36.63z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M136.66 76.07h326.68A36.63 36.63 0 01500 112.7v211.83c0 110.44-134.27 200-200 200h0c-69.51 0-200-89.53-200-200V112.7a36.63 36.63 0 0136.66-36.63z",
  strokeWidth: 8,
  stroke: "#5f2779",
  fill: "none"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#security-tier-2_svg__clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  transform: "rotate(35.7 325.157 288.493)",
  opacity: 0.4,
  fill: "url(#security-tier-2_svg__linear-gradient-4)",
  d: "M243.71-28h162.83v632.87H243.71z"
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "security-tier-2_svg__cls-1",
  d: "M136.66 76.07h326.68A36.63 36.63 0 01500 112.7v211.83c0 110.44-134.27 200-200 200-69.51 0-200-89.53-200-200V112.7a36.63 36.63 0 0136.66-36.63z"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  className: "security-tier-2_svg__cls-7",
  x: 119.98,
  y: 105.48,
  width: 107.15,
  height: 24.2,
  rx: 12.1
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  className: "security-tier-2_svg__cls-7",
  x: 246.28,
  y: 105.48,
  width: 107.15,
  height: 24.2,
  rx: 12.1
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 372.59,
  y: 105.48,
  width: 107.15,
  height: 24.2,
  rx: 12.1,
  fill: "#954293"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  className: "security-tier-2_svg__cls-9",
  cx: 227.06,
  cy: 173.22,
  r: 6.01
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  className: "security-tier-2_svg__cls-9",
  cx: 308.65,
  cy: 194.13,
  r: 3.01
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  className: "security-tier-2_svg__cls-9",
  cx: 124.04,
  cy: 220.87,
  r: 3.01
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  className: "security-tier-2_svg__cls-9",
  cx: 435.85,
  cy: 399.94,
  r: 6.01
});

var _ref15 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  className: "security-tier-2_svg__cls-11",
  d: "M476.31 234.55v13.97M483.29 241.54h-13.97"
}));

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "security-tier-2_svg__cls-12",
  d: "M131.02 321.55v13.97M138.01 328.53h-13.97"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M299.11 248L159.7 201.28a4.66 4.66 0 00-6.14 4.41v172.63a4.66 4.66 0 003.18 4.42l142.37 47.69a2.72 2.72 0 001.78 0l142.37-47.69a4.66 4.66 0 003.18-4.42V205.69a4.66 4.66 0 00-6.14-4.41L300.89 248a2.85 2.85 0 01-1.78 0z",
  fill: "#1c988a"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M430.16 205.85l-1.07.35a4.11 4.11 0 00-5.35-3.23l-.22.08a4 4 0 00-4.69-1.81l-118.08 39.55a2.27 2.27 0 01-1.5 0l-118.08-39.55a4 4 0 00-4.69 1.81l-.22-.08a4.11 4.11 0 00-5.35 3.23l-1.07-.35a4.31 4.31 0 00-5.69 4.09V370.1a4.31 4.31 0 002.94 4.09l132.09 44.25a2.56 2.56 0 001.64 0l132.09-44.25a4.31 4.31 0 002.94-4.09V209.94a4.31 4.31 0 00-5.69-4.09z",
  fill: "url(#security-tier-2_svg__linear-gradient-5)"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "security-tier-2_svg__cls-15",
  d: "M184.86 229.21l99.23 33.77M184.39 250.36l99.23 33.77M183.92 271.56l99.23 33.77M183.46 292.7l99.23 33.77M182.99 314.06l99.23 33.77M182.52 335.2l99.23 33.77M182.05 356.63l99.23 33.76M317.44 390.39l99.23-33.76M316.97 369.25l99.23-33.77M316.5 348.05l99.23-33.77M316.04 326.9l99.23-33.77M315.57 305.55l99.23-33.77M315.1 284.4l99.23-33.77M314.63 262.98l99.23-33.77"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M316.69 369.89l-7.76-4.09a.94.94 0 00-1 .11l-7.13 5.92a.93.93 0 01-1.52-.72V240.79l18.8-6.06v134.33a.93.93 0 01-1.39.83z",
  fill: "url(#security-tier-2_svg__linear-gradient-6)"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M136.66 76.07h326.68A36.63 36.63 0 01500 112.7v211.83c0 110.44-134.27 200-200 200h0c-69.51 0-200-89.53-200-200V112.7a36.63 36.63 0 0136.66-36.63z",
  stroke: "#371447",
  opacity: 0.7,
  strokeWidth: 10,
  strokeMiterlimit: 10,
  fill: "none"
});

function SvgSecurityTier2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "security-tier-2_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
}

export default SvgSecurityTier2;